import { i18n } from "../i18n";

export const FORMAT_CURRENCY: Intl.NumberFormatOptions = {
    style: "currency",
    currency: "EUR",
};

export function formatNumber(n: number, options = FORMAT_CURRENCY): string {
    return n.toLocaleString(i18n.languages, options);
}
